import CSS from './Home.module.css';

const Home = () => (
  <main className={CSS.homeScreen} aria-label="Home" />
);

export default Home;
